import React from 'react';
import {Card, Spin} from 'antd';

const GroupCard = ({title, count, backgroundColor, loading}) => {
    return (
        <Card
            type="inner"
            bodyStyle={{backgroundColor}}
            size="small"
            title={title}
            style={{textAlign: 'center'}}
        >
            {loading ? (
                <Spin style={{display: 'block', margin: '8px auto'}} size="small"/>
            ) : (
                <span style={{fontSize: '14px', fontWeight: '500'}}>
                    {count !== null ? count : '—'}
                </span>
            )}
        </Card>
    );
};

export default GroupCard;
